var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBuilding(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 21.4082V24.4082H23V21.4082H30V28.4082C30 28.6734 29.8946 28.9278 29.7071 29.1153C29.5196 29.3028 29.2652 29.4082 29 29.4082H11C10.7348 29.4082 10.4804 29.3028 10.2929 29.1153C10.1054 28.9278 10 28.6734 10 28.4082V21.4082H17ZM19 19.4082H21V22.4082H19V19.4082ZM15 13.4082V10.4082C15 10.143 15.1054 9.88863 15.2929 9.7011C15.4804 9.51356 15.7348 9.4082 16 9.4082H24C24.2652 9.4082 24.5196 9.51356 24.7071 9.7011C24.8946 9.88863 25 10.143 25 10.4082V13.4082H29C29.2652 13.4082 29.5196 13.5136 29.7071 13.7011C29.8946 13.8886 30 14.143 30 14.4082V19.4082H23V17.4082H17V19.4082H10V14.4082C10 14.143 10.1054 13.8886 10.2929 13.7011C10.4804 13.5136 10.7348 13.4082 11 13.4082H15ZM17 11.4082V13.4082H23V11.4082H17Z",
    fill: "#713FFF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding);
export default __webpack_public_path__ + "static/media/building.ecff3f86.svg";
export { ForwardRef as ReactComponent };